module.exports = __webpack_public_path__ + "static/media/roanoke-map.496bfa50.jpg";